//TODO Add hashes for addtional sites here

if(window.location.hash !== "homepage" || window.location.hash !== "next"){
    window.location.hash = "homepage"
}
